module.exports = __webpack_public_path__ + "static/media/dragon-kingdom-eyes-of-fire.3767973e.gif";